import colorPalette from '../color-palette';

const { background, text } = colorPalette;

export default {
  MuiTextField: {
    root: {
      '& input': {
        backgroundColor: background.textInput,
        padding: 0,
        height: '100%',
        boxSizing: 'border-box',
        color: text.primary,
        fontWeight: 700,
        '&::placeholder': {
          fontWeight: 400,
        },
      },
      '& label': {
        zIndex: 1,
      },
    },
  },
};
